export const CREATE_SELF_CARE_ACCOUNT =
  'app/self_care/create_self_care_account';
export const SEARCH_BUNDLES = 'app/self_care/SEARCH_BUNDLES';
